<script>
import Form from '@wielink-application/asset/vue/assets/_form.vue'
export default Form;
</script>